<template>
  <div>
    <v-layout
      v-if="$vuetify.breakpoint.xs"
      align-center
      style="background-color: #f7f8fb"
    >
      <v-flex
        xs11
        mt-3
        class="text-xs-center"
      >
        <p class="header fw-600 sz_grafit--text">
          {{ $t('filters.title') }}
        </p>
      </v-flex>

      <v-spacer />
      <v-flex
        xs1
        @click="$emit('dialog', false)"
      >
        <BaseIcon
          height="24px"
          width="24px"
        >
          <CloseIcon />
        </BaseIcon>
      </v-flex>
    </v-layout>

    <v-layout
      :wrap="$vuetify.breakpoint.smAndDown"
      :px-3="$vuetify.breakpoint.xs"
    >
      <v-flex
        :shrink="$vuetify.breakpoint.mdAndUp"
        md5
        :pr-5="$vuetify.breakpoint.mdAndUp"
      >
        <v-checkbox
          v-model="showExternalFamilies"
          :label="$t('families_to_accept.external_filter')"
          type="checkbox"
          @change="toggleExternalFamilies()"
        />
      </v-flex>
      <v-flex
        md6
        :pl-2="$vuetify.breakpoint.mdAndUp && hasFamilyToAcceptExternalPermission"
      >
        <v-layout
          :wrap="$vuetify.breakpoint.xs"
          :justify-center="$vuetify.breakpoint.xs"
        >
          <v-flex mr-2>
            <v-select
              ref="provinceFilter"
              v-model="filteredProvinces"
              multiple
              :items="provinces"
              item-text="name"
              item-value="province_id"
              :label="$t('label.province')"
              append-icon="expand_more"
            >
              <template
                slot="selection"
                slot-scope="data"
              >
                <span v-if="filteredProvinces.length === 1">
                  {{ provinces.find((el) => el.province_id === filteredProvinces[0]).name }}
                </span>
                <span v-if="filteredProvinces.length > 1 && data.index === 1">
                  {{ filteredProvinces.length }} z {{ provinces.length }}
                </span>
              </template>
            </v-select>
          </v-flex>
          <v-flex shrink>
            <v-layout
              fill-height
              column
              :align-center="$vuetify.breakpoint.smAndDown"
              :align-start="$vuetify.breakpoint.mdAndUp"
            >
              <v-btn
                color="sz_violet"
                class="mr-0 ml-1 mt-3 text-none border-none"
                flat
                :outline="isFilterEmpty"
                :disabled="isFilterEmpty"
                @click="filtered"
              >
                <BaseIcon>
                  <FiltersIcon />
                </BaseIcon>
                {{ $t('filters.filter') }}
              </v-btn>
              <v-btn
                color="sz_violet"
                class="mr-0 ml-1 mt-3 text-none border-none"
                flat
                :outline="isFilterEmpty"
                :disabled="isFilterEmpty"
                @click="resetFilters"
              >
                {{ $t('buttons.reset_filters') }}
              </v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import BaseIcon from '@/icons/BaseIcon';
import FiltersIcon from '@/icons/FiltersIcon';
import CloseIcon from '@/icons/CloseIcon';
import permissions from '@/constants/permissions';

export default {
    name: 'ToAcceptFiltersBar',
    components: { BaseIcon, FiltersIcon, CloseIcon },
    data () {
        return {
            permissions,
            showExternalFamilies: null,
            filteredProvinces: null,
            hasFamilyToAcceptExternalPermission: null
        };
    },
    computed: {
        provinces () {
            return this.$store.getters['defaultApi/getProvincesForFamiliesToAccept'];
        },
        isFilterEmpty () {
            const provinces = this.filteredProvinces && this.filteredProvinces.length > 0;
            return this.showExternalFamilies !== true && provinces !== true;
        }
    },
    watch: {
        filteredProvinces: {
            handler (val) {
                this.$emit('changeFilteredProvinces', val);
            }
        }
    },
    created () {
        this.$store
            .dispatch('auth/hasPermission', this.permissions.FAMILY_TO_ACCEPT_EXTERNAL)
            .then((res) => {
                this.hasFamilyToAcceptExternalPermission = res;
            });
    },
    methods: {
        filtered () {
            this.$emit('filtered');
            this.closeDialog();
        },
        resetFilters () {
            this.filteredProvinces = [];
            this.showExternalFamilies = null;
            this.$emit('changeFilteredProvinces', this.filteredProvinces);
            this.$emit('changeShowExternalFamilies', this.showExternalFamilies);
            this.$emit('resetFilters');
            this.closeDialog();
        },
        reset () {
            this.filteredProvinces = [];
            this.$refs.provinceFilter.blur();
        },
        hide () {
            this.$refs.provinceFilter.blur();
        },
        closeDialog () {
            if (this.$vuetify.breakpoint.xsOnly) {
                this.$emit('dialog', false);
            }
        },
        toggleExternalFamilies () {
            this.$emit('changeShowExternalFamilies', this.showExternalFamilies);
            this.$emit('toggleExternalFamilies');
            this.closeDialog();
        }
    }
};
</script>

<style scoped>
.border-none {
  border: 0 !important;
}
</style>
